import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import Translate from 'react-translate-component';
import { Button, Col, Row } from 'antd';
import { map } from 'ramda';

import ErrorHTML from 'components/common/form/ErrorHTML';
import withAutoFocusForm from 'components/hocs/withAutoFocusForm';
import Text from 'components/common/form/Text';
import ApprovalTags from 'components/modals/approvals/ApprovalTags';
import withLimitCounter from 'components/hocs/withLimitCounter';
import withFormWrapper from 'components/hocs/withFormWrapper';
import { required } from 'utils/validators';

const TextWithLimitCounter = withLimitCounter(Text);

@withAutoFocusForm
@withFormWrapper({
    mapPropsToValues: props => ({
        ids: map(({ id, key }) => (id || key), props.params),
        params: props.params,
        title: props.title
    })
})
export default class CommentForm extends Component {
    static propTypes = {
        formAction: PropTypes.object.isRequired,
        params: PropTypes.array.isRequired,
        title: PropTypes.string.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        mapper: PropTypes.func,
        required: PropTypes.bool,
        user: PropTypes.object,
        limit: PropTypes.number,
    }

    required = value => {
        return this.props.required && required(value);
    }

    render () {
        const { handleSubmit, title, params, mapper, limit, formAction: { meta } } = this.props;
        const tags = mapper && mapper(params);

        return (
            <div className='comment-form'>
                <ApprovalTags tags={tags} />

                <Field
                    name='comment'
                    component={TextWithLimitCounter}
                    autoSize={{ minRows: 4, maxRows: 6 }}
                    placeholder='placeholders.comment'
                    validate={this.required}
                    maxLength={limit || 511}
                />

                <Row>
                    <Col xs={{ span: 18 }} className="alert-inline">
                        <ErrorHTML meta={meta} />
                    </Col>
                    <Col xs={{ span: 6 }} className="text-right">
                        <Button htmlType='submit' type='blue' onClick={handleSubmit}>
                            <Translate content={`button.${title}`} />
                        </Button>
                    </Col>
                </Row>
            </div>
        );
    }
}
